<form [formGroup]="form" #container class="w-full block">
  <label #subtitleLabel [class]="disabled ? 'text-label-disabled' : 'text-label'">
    {{ label }}
    @if (disabled && disabledLabel) {
      <b class="text-sub-label"> {{ disabledLabel }} </b>
    }
  </label>

  <div
    #inbox
    class="w-full h-10 flex items-center px-2 rounded-sm shadow-lg border bg-white"
    [class.border-disabled]="disabled"
    [class.border-enabled]="!disabled && !offTimeOut"
    [class.border-error]="!disabled && offTimeOut"
  >
    <input
      #input
      type="text"
      formControlName="search"
      [placeholder]="placeholder"
      class="w-full h-full border-none outline-none focus:ring-0 px-3 placeholder:text-gray-400"
      [class.cursor-not-allowed]="disabled"
      [readonly]="disabled"
      (input)="onInput()"
      (blur)="onBlur()"
    />
  </div>

  @if (filtered.length > 0 && !disabled) {
    <ul class="max-h-[300px] mt-2 bg-white border border-gray-200 overflow-y-auto">
      @for (item of filtered; track $index) {
        <li
          class="p-2 hover:bg-gray-100 cursor-pointer"
          (click)="select(item)"
        >
          {{ item[labelKey] }}
        </li>
      }
    </ul>
  }

  @if (showNoResults && !disabled) {
    <div class="text-red-500 text-[10px] mt-1">
      No se encontraron coincidencias
    </div>
  }

  @if (offTimeOut && !showNoResults && !disabled) {
    <div class="text-red-500 text-[10px] mt-1">
      Por favor selecciona un elemento de la lista.
    </div>
  }
</form>
